import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "product-hotspot",
  class ProductHotspot extends WYATTElement {
    connectedCallback() {
      this.config = {
        activeClass: "product-hotspot--active",
        mouseExitDelay: 400,
      };
      this.tooltip = this.querySelector("[data-product-hotspot-tooltip]");
      this.mouseEnterDelay = undefined;
      this.mouseExitDelay = undefined;
      this.active = false;
      this.positionTooltip();

      this.addEventListener("mouseenter", this.showTooltip.bind(this));
      this.addEventListener("focusin", this.showTooltip.bind(this));
      this.addEventListener("mouseleave", this.hideTooltip.bind(this));
      this.addEventListener("focusout", this.hideTooltip.bind(this));
    }

    showTooltip() {
      if (this.isActive) {
        clearTimeout(this.mouseExitDelay);
        return;
      }

      this.positionTooltip();
      this.classList.add(this.config.activeClass);
      this.isActive = true;
    }

    hideTooltip() {
      clearTimeout(this.mouseExitDelay);

      if (!this.isActive) {
        return;
      }

      this.mouseExitDelay = setTimeout(() => {
        this.classList.remove(this.config.activeClass);
        this.isActive = false;
      }, this.config.mouseExitDelay);
    }

    positionTooltip() {
      const {
        bottom: hotspotBottom,
        left: hotspotLeft,
        width: hotspotWidth,
      } = this.getBoundingClientRect();
      const viewportWidth = document.documentElement.clientWidth;
      const { width: tooltipWidth, height: tooltipHeight } =
        this.tooltip.getBoundingClientRect();
      const hotspotOffset = hotspotWidth / 2;
      const hotspotHorizontalCenter = hotspotLeft + hotspotOffset;

      if (hotspotBottom + tooltipHeight > window.innerHeight) {
        this.tooltip.style.top = "auto";
        this.tooltip.style.bottom = "120%";
      } else {
        this.tooltip.style.top = "100%";
        this.tooltip.style.bottom = "auto";
      }

      if (hotspotHorizontalCenter < tooltipWidth / 2) {
        this.tooltip.style.transform = "translateX(0)";
      } else if (hotspotHorizontalCenter + tooltipWidth / 2 > viewportWidth) {
        this.tooltip.style.transform = `translateX(calc(-100% + ${hotspotWidth}px))`;
      } else {
        this.tooltip.style.transform = `translateX(calc(-50% + ${hotspotOffset}px))`;
      }
    }
  },
);
